(function () {
  'use strict';

  // ============================================================
  // Device icons
  // ============================================================
  var ICONS = {
    refrigerator: '<rect x="5" y="2" width="14" height="20" rx="2"/><path d="M5 10h14"/><path d="M9 5v2M9 13v3"/>',
    washer: '<rect x="4" y="3" width="16" height="18" rx="1.5"/><circle cx="12" cy="14" r="4"/><path d="M8 7h.01M12 7h.01M16 7h.01"/>',
    dishwasher: '<rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M4 8h16"/><path d="M8 5h.01M12 5h.01M16 5h.01"/><path d="M7 12h10M7 15h10M7 18h10"/>',
    microwave: '<rect x="2" y="6" width="20" height="12" rx="1.5"/><rect x="5" y="9" width="9" height="6" rx="0.5"/><path d="M18 9v1M18 13v1"/>',
    coffee: '<path d="M4 8h12v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M16 10h2a2 2 0 0 1 0 4h-2"/><path d="M7 4v2M11 4v2M15 4v2"/>',
    kettle: '<path d="M5 10h12v6a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3z"/><path d="M17 12h2a2 2 0 0 1 0 4h-2"/><path d="M10 6l-2-2M12 4v2"/>',
    toaster: '<rect x="3" y="8" width="18" height="10" rx="1.5"/><path d="M7 8V6M11 8V6M15 8V6M19 8V6"/>',
    laptop: '<rect x="4" y="4" width="16" height="12" rx="1"/><path d="M2 18h20"/>',
    tv: '<rect x="3" y="5" width="18" height="12" rx="1"/><path d="M8 21h8M12 17v4"/>',
    router: '<rect x="3" y="14" width="18" height="6" rx="1"/><path d="M7 17h.01M11 17h.01"/><path d="M8 10l-3-3M16 10l3-3M12 10V6"/>',
    phone: '<rect x="7" y="2" width="10" height="20" rx="1.5"/><path d="M11 18h2"/>',
    fan: '<circle cx="12" cy="12" r="2"/><path d="M12 10c0-3 1-6 3-6s3 3 0 6"/><path d="M14 12c3 0 6 1 6 3s-3 3-6 0"/><path d="M12 14c0 3-1 6-3 6s-3-3 0-6"/><path d="M10 12c-3 0-6-1-6-3s3-3 6 0"/>',
    bulb: '<path d="M9 18h6"/><path d="M10 21h4"/><path d="M12 3a6 6 0 0 1 4 10.5V16H8v-2.5A6 6 0 0 1 12 3z"/>',
    water: '<path d="M12 3s6 7 6 12a6 6 0 0 1-12 0c0-5 6-12 6-12z"/>',
    heater: '<rect x="4" y="6" width="16" height="12" rx="1"/><path d="M8 6v12M12 6v12M16 6v12"/>',
    snowflake: '<path d="M12 2v20M4.5 6.5l15 11M19.5 6.5l-15 11"/><path d="M10 4l2 2 2-2M10 20l2-2 2 2"/>',
    stove: '<rect x="3" y="8" width="18" height="12" rx="1.5"/><path d="M3 12h18"/><circle cx="7" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="17" cy="16" r="1"/>',
    grill: '<path d="M4 6h16"/><path d="M6 6l1 12h10l1-12"/><path d="M9 20h6"/>',
    drill: '<path d="M3 8h10v6H3z"/><path d="M13 9h4v4h-4z"/><path d="M17 10h3M19 9v3"/><path d="M6 14v6a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-6"/>',
    blender: '<path d="M6 4h10l-1 14a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3z"/><path d="M6 8h12M11 4V2"/>',
    vacuum: '<circle cx="10" cy="16" r="4"/><path d="M10 12V4h6a2 2 0 0 1 2 2v6"/><path d="M18 14h3"/>',
    medical: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v8M8 12h8"/>',
    camera: '<rect x="3" y="6" width="14" height="12" rx="1.5"/><path d="M17 10l4-2v8l-4-2z"/><circle cx="9" cy="12" r="2.5"/>',
    bell: '<path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4z"/><path d="M10 20a2 2 0 0 0 4 0"/>',
    speaker: '<rect x="5" y="3" width="14" height="18" rx="1.5"/><circle cx="12" cy="14" r="3"/><circle cx="12" cy="7" r="1.5"/>',
    printer: '<path d="M6 9V3h12v6"/><rect x="4" y="9" width="16" height="8" rx="1"/><rect x="7" y="14" width="10" height="7"/>',
    ev: '<path d="M5 4h10v14l-2.5 3h-5L5 18z"/><path d="M10 4v14"/><circle cx="7.5" cy="20" r="1.5"/><circle cx="12.5" cy="20" r="1.5"/>',
    tent: '<path d="M12 3L2 21h20z"/><path d="M12 3v18"/>',
    pos: '<rect x="4" y="3" width="16" height="14" rx="1.5"/><path d="M8 21h8M12 17v4"/><path d="M8 7h8M8 11h8"/>',
    iron: '<path d="M3 18h18v2H3z"/><path d="M5 18V12a4 4 0 0 1 4-4h6l3 3v7"/>',
    default: '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M8 18v2M16 18v2"/><circle cx="12" cy="12" r="2"/>'
  };

  var ICON_RULES = [
    { icon: 'dishwasher', keys: ['dishwasher', 'dish washer'] },
    { icon: 'washer', keys: ['washing machine', 'washer', 'dryer', 'laundry'] },
    { icon: 'refrigerator', keys: ['refrigerator', 'fridge', 'freezer'] },
    { icon: 'microwave', keys: ['microwave'] },
    { icon: 'snowflake', keys: ['air conditioner', 'air conditioning', 'heat pump', 'cooling', 'rv ac'] },
    { icon: 'water', keys: ['water heater', 'water pump', 'sump pump', 'sprinkler', 'pool pump', 'fountain', 'well pump', 'water'] },
    { icon: 'heater', keys: ['space heater', 'patio heater', 'hot tub', 'baseboard', 'furnace', 'heating', 'heater'] },
    { icon: 'coffee', keys: ['coffee maker', 'coffee', 'espresso'] },
    { icon: 'kettle', keys: ['electric kettle', 'kettle'] },
    { icon: 'toaster', keys: ['toaster', 'toaster oven'] },
    { icon: 'vacuum', keys: ['vacuum'] },
    { icon: 'medical', keys: ['cpap', 'oxygen concentrator', 'oxygen', 'concentrator', 'medical'] },
    { icon: 'camera', keys: ['security camera', 'camera'] },
    { icon: 'bell', keys: ['alarm system', 'alarm'] },
    { icon: 'router', keys: ['wi-fi', 'wifi', 'router', 'modem'] },
    { icon: 'phone', keys: ['phone charger', 'device charger', 'charger', 'phone', 'tablet'] },
    { icon: 'speaker', keys: ['speaker', 'audio', 'sound system'] },
    { icon: 'printer', keys: ['printer', 'pos system', 'cash register', 'register'] },
    { icon: 'laptop', keys: ['laptop', 'work computer', 'computer', 'workstation'] },
    { icon: 'tv', keys: ['television', 'tv', 'monitor', 'display', 'menu board'] },
    { icon: 'ev', keys: ['ev charger', 'vehicle', 'electric car', 'golf cart'] },
    { icon: 'tent', keys: ['camping', 'tent'] },
    { icon: 'blender', keys: ['blender', 'food processor', 'mixer', 'processor'] },
    { icon: 'stove', keys: ['flat-top griddle', 'griddle', 'deep fryer', 'fryer', 'induction cooktop', 'cooktop', 'range', 'oven', 'stove', 'microwave oven'] },
    { icon: 'grill', keys: ['electric grill', 'grill', 'bbq', 'barbecue'] },
    { icon: 'drill', keys: ['circular saw', 'table saw', 'miter saw', 'band saw', 'angle grinder', 'belt sander', 'pressure washer', 'air compressor', 'drill press', 'welding', 'welder', 'saw', 'drill', 'grinder', 'sander', 'router tool', 'compressor', 'heat gun', 'nail gun', 'paint sprayer', 'sprayer'] },
    { icon: 'fan', keys: ['ceiling fan', 'exhaust fan', 'box fan', 'tower fan', 'portable fan', 'fan'] },
    { icon: 'bulb', keys: ['flood lights', 'work light', 'string lights', 'menu board light', 'light', 'led', 'lamp', 'bulb', 'lighting'] },
    { icon: 'iron', keys: ['iron'] }
  ];

  function getDeviceIcon(deviceName) {
    var n = String(deviceName || '').toLowerCase();
    for (var i = 0; i < ICON_RULES.length; i++) {
      var rule = ICON_RULES[i];
      for (var j = 0; j < rule.keys.length; j++) {
        if (n.indexOf(rule.keys[j]) !== -1) return ICONS[rule.icon] || ICONS['default'];
      }
    }
    return ICONS['default'];
  }
  function svgWrap(inner) {
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
  }

  // ============================================================
  // GraphQL
  // ============================================================
  var LEVEL1_QUERY = [
    'query GetLevel1($type: String!, $first: Int!) {',
    '  metaobjects(type: $type, first: $first) {',
    '    edges { node { id handle fields { key value } } }',
    '  }',
    '}'
  ].join('\n');

  var LEVEL2_QUERY = [
    'query GetLevel2($type: String!, $first: Int!, $after: String) {',
    '  metaobjects(type: $type, first: $first, after: $after) {',
    '    edges { node { id handle fields { key value } } }',
    '    pageInfo { hasNextPage endCursor }',
    '  }',
    '}'
  ].join('\n');

  var DEVICE_QUERY = [
    'query GetDevices($type: String!, $first: Int!, $after: String) {',
    '  metaobjects(type: $type, first: $first, after: $after) {',
    '    edges {',
    '      cursor',
    '      node {',
    '        id handle type',
    '        fields {',
    '          key value type',
    '          reference { ... on Metaobject { id handle type } }',
    '        }',
    '      }',
    '    }',
    '    pageInfo { hasNextPage endCursor }',
    '  }',
    '}'
  ].join('\n');

  // ============================================================
  // Helpers
  // ============================================================
  function parseConfig(root) {
    var script = root.querySelector('script[data-dps-config]');
    if (!script) return { __error: 'No config script found.' };
    var raw = script.textContent || '';
    if (!raw.trim()) return { __error: 'Config script empty.' };
    try { return JSON.parse(raw); }
    catch (e) { return { __error: 'JSON.parse failed: ' + e.message + '\nFirst 300 chars:\n' + raw.slice(0, 300) }; }
  }
  function getField(node, key) {
    if (!node || !node.fields) return null;
    for (var i = 0; i < node.fields.length; i++) {
      if (node.fields[i].key === key) return node.fields[i];
    }
    return null;
  }
  function getVal(node, key) {
    var f = getField(node, key);
    return f && f.value != null ? String(f.value) : '';
  }
  function getRef(node, key) {
    var f = getField(node, key);
    return f && f.reference ? f.reference : null;
  }
  function toInt(v, fb) {
    var n = parseInt(v, 10);
    return isNaN(n) ? (fb || 0) : n;
  }
  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function showError(root, msg) {
    var target = root.querySelector('[data-dps-panels]') || root.querySelector('.product-scenes__panels');
    if (target) target.innerHTML = '<pre style="color:#b00020;font-size:12px;white-space:pre-wrap;background:#fff5f5;padding:12px;border-radius:6px;overflow:auto;">' + escapeHtml(msg) + '</pre>';
    root.querySelectorAll('.product-scenes__loading').forEach(function (el) { el.style.display = 'none'; });
  }
  function gqlFetch(url, headers, query, variables) {
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify({ query: query, variables: variables }) })
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('HTTP ' + r.status + '\n' + t.slice(0, 400)); });
        return r.json();
      })
      .then(function (json) {
        if (json.errors && json.errors.length) throw new Error('GraphQL: ' + JSON.stringify(json.errors).slice(0, 600));
        return json.data;
      });
  }
  function fetchAllByType(config, type, query) {
    var sf = config.storefront;
    var url = 'https://' + config.shop_domain + '/api/' + sf.version + '/graphql.json';
    var headers = { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token };
    var all = []; var page = 0; var after = null;
    function fetchPage() {
      page++;
      if (page > sf.max_pages) return Promise.resolve(all);
      return gqlFetch(url, headers, query, { type: type, first: sf.page_size, after: after })
        .then(function (data) {
          var conn = data && data.metaobjects;
          if (!conn) return all;
          (conn.edges || []).forEach(function (e) { all.push(e.node); });
          if (conn.pageInfo && conn.pageInfo.hasNextPage && page < sf.max_pages) {
            after = conn.pageInfo.endCursor;
            return fetchPage();
          }
          return all;
        });
    }
    return fetchPage();
  }
  function buildLevel2Map(level2Nodes) {
    var map = {};
    (level2Nodes || []).forEach(function (n) {
      var name = getVal(n, 'name');
      if (n.id && name) map[n.id] = name;
    });
    return map;
  }
  function deviceMatchesScene(node, sceneGid, sceneHandle) {
    var ref = getRef(node, 'category_level1');
    if (!ref) return false;
    if (sceneGid && ref.id === sceneGid) return true;
    if (sceneHandle && ref.handle === sceneHandle) return true;
    return false;
  }
  function buildGroups(devices, panel, config, level2Map) {
    var sceneGid = panel.getAttribute('data-scene-gid');
    var sceneHandle = panel.getAttribute('data-scene-panel');
    var productRun = config.product.running_watt;
    var productStart = config.product.starting_watt;
    var checkStart = productStart > 0;
    var groups = {}; var order = [];
    devices.forEach(function (node) {
      if (!deviceMatchesScene(node, sceneGid, sceneHandle)) return;
      var runW = toInt(getVal(node, 'wattage'), 0);
      var startW = toInt(getVal(node, 'starting_wattage'), 0);
      if (startW < runW) startW = runW;
      var qty = toInt(getVal(node, 'default_quantity'), 1);
      if (qty < 1) qty = 1;
      var totalRun = runW * qty;
      if (totalRun > productRun) return;
      if (checkStart && startW > productStart) return;
      var ref2 = getRef(node, 'category_level2');
      var gname = 'Uncategorized';
      if (ref2 && ref2.id && level2Map[ref2.id]) gname = level2Map[ref2.id];
      else if (ref2 && ref2.handle) gname = ref2.handle.replace(/-/g, ' ');
      if (!groups[gname]) { groups[gname] = []; order.push(gname); }
      groups[gname].push({
        name: getVal(node, 'device_name') || node.handle || '(unnamed)',
        run: totalRun, qty: qty
      });
    });
    return order.map(function (k) { return { name: k, items: groups[k] }; });
  }
  function renderPanel(panel, devices, config, level2Map) {
    var groupsEl = panel.querySelector('[data-scene-groups]');
    var loadingEl = panel.querySelector('.product-scenes__loading');
    if (loadingEl) loadingEl.style.display = 'none';
    if (!groupsEl) return;
    var groups = buildGroups(devices, panel, config, level2Map);
    if (!groups.length) {
      groupsEl.innerHTML = '<p class="product-scenes__empty">No loadable devices available.</p>';
      return;
    }
    var html = '';
    groups.forEach(function (g) {
      html += '<div class="product-scenes__group"><h4 class="product-scenes__group-title">' + escapeHtml(g.name) + '</h4><ul class="product-scenes__list">';
      g.items.forEach(function (it) {
        var iconSvg = svgWrap(getDeviceIcon(it.name));
        html += '<li class="product-scenes__item">';
        html += '<span class="product-scenes__item-icon" aria-hidden="true">' + iconSvg + '</span>';
        html += '<span class="product-scenes__item-text"><span class="product-scenes__item-name">' + escapeHtml(it.name) + '</span>';
        if (it.qty > 1) html += '<span class="product-scenes__item-sub">(\u00d7' + it.qty + ')</span>';
        html += '</span>';
        html += '<span class="product-scenes__item-watt">' + it.run + 'W</span></li>';
      });
      html += '</ul></div>';
    });
    groupsEl.innerHTML = html;
  }

  // ============================================================
  // Mode A: section
  // ============================================================
  function initSectionMode(root) {
    if (!root || root.dataset.dpsInit === '1') return;
    root.dataset.dpsInit = '1';
    var config = parseConfig(root);
    if (!config || config.__error) { showError(root, config && config.__error ? config.__error : 'Config parse error'); return; }
    if (!config.storefront || !config.storefront.token || !config.shop_domain) { showError(root, 'Missing token or shop_domain.'); return; }

    var tabs = root.querySelectorAll('[data-scene-tab]');
    var panels = root.querySelectorAll('[data-scene-panel]');
    function activate(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-scene-tab') === key;
        t.classList.toggle('product-scenes__tab--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-scene-panel') === key;
        p.style.display = on ? 'block' : 'none';
      });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) { e.preventDefault(); activate(tab.getAttribute('data-scene-tab')); });
    });

    Promise.all([
      fetchAllByType(config, config.metaobject_types.level2, LEVEL2_QUERY),
      fetchAllByType(config, config.metaobject_types.option, DEVICE_QUERY)
    ]).then(function (results) {
      var level2Nodes = results[0]; var devices = results[1];
      if (!devices.length) { showError(root, 'API returned 0 devices.'); return; }
      var level2Map = buildLevel2Map(level2Nodes);
      panels.forEach(function (p) { renderPanel(p, devices, config, level2Map); });
    }).catch(function (err) {
      console.error('[DPS]', err);
      showError(root, 'Failed to load:\n' + (err && err.message ? err.message : String(err)));
    });
  }

  // ============================================================
  // Mode B: mount (JS builds UI)
  // ============================================================
  function initMountMode(root) {
    if (!root || root.dataset.dpsInit === '1') return;
    root.dataset.dpsInit = '1';
    var config = parseConfig(root);
    if (!config || config.__error) { showError(root, config && config.__error ? config.__error : 'Config parse error'); return; }
    if (!config.storefront || !config.storefront.token || !config.shop_domain) { showError(root, 'Missing token or shop_domain.'); return; }

    var tabsContainer = root.querySelector('[data-dps-tabs]');
    var panelsContainer = root.querySelector('[data-dps-panels]');
    if (!tabsContainer || !panelsContainer) { showError(root, 'Missing [data-dps-tabs] or [data-dps-panels].'); return; }

    // Build level1 image map from config
    var level1Images = {};
    (config.level1_images || []).forEach(function (item) {
      if (item && item.handle && item.url) level1Images[item.handle] = item.url;
    });

    Promise.all([
      fetchAllByType(config, config.metaobject_types.level1, LEVEL1_QUERY),
      fetchAllByType(config, config.metaobject_types.level2, LEVEL2_QUERY),
      fetchAllByType(config, config.metaobject_types.option, DEVICE_QUERY)
    ]).then(function (results) {
      var level1Nodes = results[0];
      var level2Nodes = results[1];
      var devices = results[2];

      if (!level1Nodes.length) { showError(root, 'No scenes found (category_level1).'); return; }
      if (!devices.length) { showError(root, 'No devices found (device_power_option).'); return; }

      var level2Map = buildLevel2Map(level2Nodes);

      tabsContainer.innerHTML = '';
      panelsContainer.innerHTML = '';

      level1Nodes.forEach(function (l1Node, idx) {
        var handle = l1Node.handle;
        var gid = l1Node.id;
        var name = getVal(l1Node, 'name') || handle;
        var imgUrl = level1Images[handle] || '';

        // Tab button
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-scenes__tab' + (idx === 0 ? ' product-scenes__tab--active' : '');
        btn.setAttribute('data-scene-tab', handle);
        btn.setAttribute('data-scene-gid', gid);
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        btn.textContent = name;
        tabsContainer.appendChild(btn);

        // Panel
        var panel = document.createElement('div');
        panel.className = 'product-scenes__panel' + (idx === 0 ? ' product-scenes__panel--active' : '');
        panel.setAttribute('data-scene-panel', handle);
        panel.setAttribute('data-scene-gid', gid);
        panel.setAttribute('role', 'tabpanel');
        panel.style.display = idx === 0 ? 'block' : 'none';

        var headHtml = '<div class="product-scenes__panel-head"><h3 class="product-scenes__panel-title">';
        if (imgUrl) {
          headHtml += '<img class="product-scenes__panel-icon" src="' + escapeHtml(imgUrl) + '" alt="" width="36" height="36" loading="lazy">';
        }
        headHtml += escapeHtml(name) + '</h3></div>';
        headHtml += '<div class="product-scenes__groups" data-scene-groups></div>';

        panel.innerHTML = headHtml;
        panelsContainer.appendChild(panel);

        renderPanel(panel, devices, config, level2Map);
      });

      // Tab switching
      var tabs = root.querySelectorAll('[data-scene-tab]');
      var panels = root.querySelectorAll('[data-scene-panel]');
      function activate(key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-scene-tab') === key;
          t.classList.toggle('product-scenes__tab--active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-scene-panel') === key;
          p.style.display = on ? 'block' : 'none';
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) { e.preventDefault(); activate(tab.getAttribute('data-scene-tab')); });
      });
    }).catch(function (err) {
      console.error('[DPS]', err);
      showError(root, 'Failed to load:\n' + (err && err.message ? err.message : String(err)));
    });
  }

  // ============================================================
  // Boot
  // ============================================================
  function initAll() {
    document.querySelectorAll('[data-product-scenes]').forEach(initSectionMode);
    document.querySelectorAll('[data-dps-mount]').forEach(initMountMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var scope = (e.target && e.target.querySelectorAll) ? e.target : document;
    scope.querySelectorAll('[data-product-scenes], [data-dps-mount]').forEach(function (el) {
      el.removeAttribute('data-dps-init');
      el.dataset.dpsInit = '';
      if (el.hasAttribute('data-product-scenes')) initSectionMode(el);
      else initMountMode(el);
    });
  });
})();